import { render, staticRenderFns } from "./GhostwritingValidation.vue?vue&type=template&id=40e1f8ae&"
import script from "./GhostwritingValidation.vue?vue&type=script&lang=js&"
export * from "./GhostwritingValidation.vue?vue&type=script&lang=js&"
import style0 from "./GhostwritingValidation.vue?vue&type=style&index=0&id=40e1f8ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports